import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";

export function* recruitUnitSaga({
  unitType,
  amount,
  govId,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "recruitUnit",
      unitType,
      amount,
      govId
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      population,
      army,
      armyCapacityUsage,
      armyFormation
    } = data;

    if (resources) {
      if (govId) {
        yield put(actions.updateMember(govId, {
          resources: {
            gold: resources.gold,
            weapons: resources.weapons,
            mana: resources.mana,
            magicEnergy: resources.magicEnergy
          },
          population: population.total,
          populationFree: population.free,
          army,
          armyCapacityUsage
        }));

        yield put(actions.updateState({
          armyFormation
        }));
      }

      if (!govId || isOwner) {
        yield put(actions.updateResources({
          resources,
          resourceBalances
        }));

        yield put(actions.updateState({
          army,
          population,
          armyCapacityUsage,
          armyFormation
        }));
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* releaseUnitSaga({
  unitType,
  amount,
  govId,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "releaseUnit",
      unitType,
      amount,
      govId
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      population,
      army,
      armyCapacityUsage,
      armyFormation
    } = data;

    if (population) {
      if (govId) {
        yield put(actions.updateMember(govId, {
          army,
          population: population.total,
          populationFree: population.free,
          armyCapacityUsage,
        }));

        yield put(actions.updateState({
          armyFormation
        }));
      }

      if (!govId || isOwner) {
        yield put(actions.updateResources({
          resources,
          resourceBalances
        }));

        yield put(actions.updateState({
          army,
          population,
          armyCapacityUsage,
          armyFormation
        }));
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* occupyPositionSaga({ position, govId, backupOrder }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "occupyBanner",
      position,
      govId,
      backupOrder
    });

    const { data } = JSON.parse(response.data);
    const {
      armyFormation
    } = data;

    yield put(actions.updateState({
      armyFormation
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* leavePositionSaga({ govId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "leaveBanner",
      govId
    });

    const { data } = JSON.parse(response.data);
    const {
      armyFormation
    } = data;

    yield put(actions.updateState({
      armyFormation
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* addBannerUnitsSaga({
  position,
  govId,
  target,
  unitId,
  tactics,
  amount
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "addBannerUnits",
      position,
      govId,
      target,
      unitId,
      tactics,
      amount
    });

    const { data } = JSON.parse(response.data);
    const {
      army,
      armyFormation,
      armyCapacityUsage,
    } = data;

    yield put(actions.updateState({
      army,
      armyFormation,
      armyCapacityUsage,
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* removeBannerUnitsSaga({
  position,
  govId,
  unitId,
  amount
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "removeBannerUnits",
      position,
      govId,
      unitId,
      amount
    });

    const { data } = JSON.parse(response.data);
    const {
      army,
      armyFormation,
      armyCapacityUsage,
    } = data;

    yield put(actions.updateState({
      army,
      armyFormation,
      armyCapacityUsage,
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* assignBannerGeneralSaga({
  bannerId
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "assignBannerGeneral",
      bannerId
    });

    const { data } = JSON.parse(response.data);
    const {
      armyFormation,
    } = data;

    yield put(actions.updateState({
      armyFormation,
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* releaseBannerGeneralSaga({
  bannerId
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "releaseBannerGeneral",
      bannerId
    });

    const { data } = JSON.parse(response.data);
    const {
      armyFormation,
    } = data;

    yield put(actions.updateState({
      armyFormation,
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* setBattleTacticsSaga({
  tacticsId
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "setBattleTactics",
      tacticsId
    });

    const { data } = JSON.parse(response.data);
    const {
      armyFormation,
    } = data;

    yield put(actions.updateState({
      armyFormation,
    }));
  } catch (error) {
    console.log(error.message);
  }
}
